require('@rails/ujs').start();
require('@rails/activestorage').start();
import '@hotwired/turbo-rails';

import 'controllers';
import ReactOnRails from 'react-on-rails';
import CreditCardSelector from '../components/responder/CreditCardSelector';
import PaymentCheckoutSelector from '../components/responder/PaymentCheckoutSelector';
import DataFieldsSelector from '../components/responder/DataFieldsSelector';
import ProgressBar from '../components/responder/ProgressBar';
import VideoBackground from '../components/responder/videoplayer/VideoBackground';
import BottomBar from '../components/responder/BottomBar';
import MultipleChoiceSelector from '../components/responder/MultipleChoiceSelector';
import DonationAmountsSelector from '../components/responder/DonationAmountsSelector';
import CustomBranding from '../components/responder/CustomBranding';
import SocialShare from '../components/responder/SocialShare';
import UgcSelector from '../components/responder/UgcSelector';
import ResponseTextField from '../components/shared/ResponseTextField';
import BackgroundOverlay from '../components/shared/BackgroundOverlay';
import SubmitButton from '../components/shared/SubmitButton';
import BrandedLabel from '../components/shared/BrandedLabel';
import NavigationButtons from '../components/shared/NavigationButtons';
import UgcUploadResponse from '../components/responder/UgcUploadResponse';
import VideoRecord from '../components/VideoRecord';
import SkipButton from '../components/responder/SkipButton';
import PaymentInfoCard from '../components/responder/PaymentInfoCard';
import BlockLabel from '../components/shared/BlockLabel';
import TitleChild from '../components/shared/TitleChild';

ReactOnRails.register({
  CreditCardSelector,
  PaymentCheckoutSelector,
  DataFieldsSelector,
  ProgressBar,
  VideoBackground,
  BottomBar,
  MultipleChoiceSelector,
  DonationAmountsSelector,
  CustomBranding,
  SocialShare,
  UgcSelector,
  ResponseTextField,
  BackgroundOverlay,
  BrandedLabel,
  NavigationButtons,
  SubmitButton,
  UgcUploadResponse,
  VideoRecord,
  SkipButton,
  PaymentInfoCard,
  BlockLabel,
  TitleChild,
});
ReactOnRails.setOptions({
  turbo: true,
  traceTurbolinks: true,
});
